import { AccordionButton, AccordionIcon, Box } from '@chakra-ui/react';

export default function RingGroupAccordionSectionButton({
    children,
    darkMode,
}) {
    return (
        <AccordionButton
            px={4}
            py={3}
            bg={darkMode ? 'dark.tcap' : undefined}
            _expanded={{ bg: darkMode ? 'dark.tcap' : undefined }}
            _hover={darkMode ? { bg: 'dark.bgDarkGray' } : {}}
            sx={
                darkMode
                    ? {}
                    : {
                          backgroundColor: 'white !important',
                          '&[aria-expanded="true"]': {
                              backgroundColor: 'white !important',
                          },
                          '&:hover': {
                              backgroundColor:
                                  'var(--chakra-colors-gray-50) !important',
                          },
                      }
            }>
            <Box
                flex="1"
                textAlign="left"
                fontWeight="600"
                fontSize="sm"
                color={darkMode ? 'white' : 'gray.700'}>
                {children}
            </Box>
            <AccordionIcon color={darkMode ? 'white' : 'gray.600'} />
        </AccordionButton>
    );
}
